import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/material.module';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { FormsModule } from '@angular/forms';
import { BrandingComponent } from '../../vertical/sidebar/branding.component';
import { AuthService } from 'src/app/services/auth.service';
import { firstValueFrom } from 'rxjs';
import { PopupComponent } from 'src/app/pages/dashboards/popup/popup.component';
import { TranslationsManagementService } from 'src/app/services/translations-management.service';

interface notifications {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface msgs {
  id: number;
  img: string;
  title: string;
  subtitle: string;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

@Component({
  selector: 'app-search-dialog',
  standalone: true,
  imports: [MaterialModule, RouterModule, TablerIconsModule, FormsModule],
  templateUrl: 'search-dialog.component.html',
})
export class AppHorizontalSearchDialogComponent {
  searchText: string = '';

}


@Component({
  selector: 'app-horizontal-header',
  standalone: true,
  imports: [MaterialModule, RouterModule, TablerIconsModule, BrandingComponent, AppHorizontalSearchDialogComponent],
  templateUrl: './header.component.html',
})
export class AppHorizontalHeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  showFiller = false;

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'EN',
    icon: '/assets/images/flag/icon-flag-en.png',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'EN',
      icon: '/assets/images/flag/icon-flag-en.png',
    },
    {
      language: 'Italiano / Italian',
      code: 'it',
      type: 'IT',
      icon: '/assets/images/flag/icon-flag-it.png',
    },
    {
      language: 'Nederlands / Dutch',
      code: 'nl',
      icon: '/assets/images/flag/icon-flag-nl.png',
    },
    {
      language: 'Euskara / Basque',
      code: 'eu',
      icon: '/assets/images/flag/icon-flag-eu.png',
    },
    {
      language: 'Català-Valencià / Catalan-Valencian',
      code: 'ca',
      icon: '/assets/images/flag/icon-flag-ca.png',
    },
    {
      language: 'Español / Spanish',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },
    {
      language: 'Slovenščina / Slovenian',
      code: 'sl',
      icon: '/assets/images/flag/icon-flag-sl.png',
    },
    {
      language: 'Ελληνικά / Greek',
      code: 'el',
      icon: '/assets/images/flag/icon-flag-el.png',
    },
    {
      language: 'Română / Romanian',
      code: 'ro',
      icon: '/assets/images/flag/icon-flag-ro.png',
    },
      {
      language: 'Deutsch / German',
      code: 'de',
      icon: '/assets/images/flag/icon-flag-de.png',
    }
  ];

  constructor(
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translateService: TranslateService,
    private router: Router,
    private authService: AuthService,
    private translationsManagementService: TranslationsManagementService
  ) {
      const language = localStorage.getItem('language');
      const found = this.languages.find((item: any) => item.code === language);
        this.selectedLanguage = found ? found : {
    language: 'English',
    code: 'en',
    type: 'EN',
    icon: '/assets/images/flag/icon-flag-en.png',
  };
  }

  openDialog() {
    const dialogRef = this.dialog.open(AppHorizontalSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
    });
  }

  changeLanguage(lang: any): void {

    this.translationsManagementService.changeLanguage(lang.code);
    this.selectedLanguage = lang;

  }

  async logout() {

    let sessionElapsedTimeInSeconds = Math.round((new Date().getTime() - this.authService.loginTime)/1000);

    try {
      await firstValueFrom(this.authService.updateLogsSessionDuration(sessionElapsedTimeInSeconds, this.authService.logId));
      this.authService.cleanVariables();
      this.authService.logoutClean();
      this.router.navigate(['/']);
      
    } catch (error: any) {

      let errorText = "error" + error.status

      //Error Popup 401
      if (errorText.indexOf("error401") != -1) {
        this.showErrorPopUp("general.errorMessageSessionExpired");
      } else {
        this.showErrorPopUp("general.errorMessage");
      }

      throw new Error(`Error in updateLogsSessionDuration() method with user id: ${this.authService.uuid} + ${this.authService.pilot}, error ${(error.status ?? 'error status not available')}, description ${(JSON.stringify(error.message) ?? 'error message not available')}, error  ${(JSON.stringify(error.error) ?? 'error.error not available')}`);

    }
   
  }

    /**
* Pop-up to show an error ocurred
*/
  showErrorPopUp(message: string) {

    //SHOW ERROR POPUP
    this.dialog.open(PopupComponent, {
      disableClose: true,
      width: '640px',
      height: '160px',
      data: {
        type: "attentionInfo",
        headerText: this.translateService.instant("login.attention"),
        generalText: this.translateService.instant(message),
        button: ["Ok"]
      },
    }).afterClosed().subscribe(async (result) => {

      if (message == 'general.errorMessageSessionExpired') {
        this.router.navigate(['/']);
      }

    })

  }

  

  notifications: notifications[] = [
    {
      id: 1,
      img: '/assets/images/profile/user-1.jpg',
      title: 'Roman Joined the Team!',
      subtitle: 'Congratulate him',
    },
    {
      id: 2,
      img: '/assets/images/profile/user-2.jpg',
      title: 'New message received',
      subtitle: 'Salma sent you new message',
    },
    {
      id: 3,
      img: '/assets/images/profile/user-3.jpg',
      title: 'New Payment received',
      subtitle: 'Check your earnings',
    },
    {
      id: 4,
      img: '/assets/images/profile/user-4.jpg',
      title: 'Jolly completed tasks',
      subtitle: 'Assign her new tasks',
    },
    {
      id: 5,
      img: '/assets/images/profile/user-5.jpg',
      title: 'Roman Joined the Team!',
      subtitle: 'Congratulate him',
    },
  ];

  msgs: msgs[] = [
    {
      id: 1,
      img: '/assets/images/profile/user-1.jpg',
      title: 'Andrew McDownland',
      subtitle: 'Message blocked. Try Again',
    },
    {
      id: 2,
      img: '/assets/images/profile/user-2.jpg',
      title: 'Christopher Jamil',
      subtitle: 'This message cannot be sent',
    },
    {
      id: 3,
      img: '/assets/images/profile/user-3.jpg',
      title: 'Julia Roberts',
      subtitle: 'You are trying to reach location.',
    },
    {
      id: 4,
      img: '/assets/images/profile/user-4.jpg',
      title: 'James Johnson',
      subtitle: 'Assign her new tasks',
    },
    {
      id: 5,
      img: '/assets/images/profile/user-5.jpg',
      title: 'Maria Rodriguez',
      subtitle: 'Congrats for your success',
    },
  ];

  profiledd: profiledd[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-account.svg',
      title: 'My Profile',
      subtitle: 'Account Settings',
      link: '/',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-inbox.svg',
      title: 'My Inbox',
      subtitle: 'Messages & Email',
      link: '/apps/email/inbox',
    },
    {
      id: 3,
      img: '/assets/images/svgs/icon-tasks.svg',
      title: 'My Tasks',
      subtitle: 'To-do and Daily Tasks',
      link: '/apps/taskboard',
    },
  ];
}

